export default {
    regions: [],
};
